/**
 * body fadeIn
 *
 */
$(window).on('load', function () {
    //    $('body').animate({
    //        opacity: 1
    //    }, 300);
    $('.js_showContent2').css({
        opacity: 1
    });

    setTimeout(function () {
        $('.js_showContent').animate({
            opacity: 1
        }, 300);
    }, 300);
});


/**
 * smooth scroll
 *
 */
$(function () {
    $('a[href^="#"]').not($('.js_pageTop a[href^="#"], a.bl_modal_trigger')).click(function () {
        var $headerHight = $('header').outerHeight(true);

        if ($('.bl_breadcrumb')[0]) {
            var $breadcrumbHeight = $('.bl_breadcrumb').outerHeight(true);
        } else {
            var $breadcrumbHeight = 0;
        }

        if ($(window).width() < 751) {
            var adjust = $headerHight + $breadcrumbHeight;
        } else {
            var adjust = $breadcrumbHeight - 10;
        }

        var speed = 400;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top - adjust;
        $("body,html").animate({
            scrollTop: position
        }, speed, "swing");
        return false;
    });
});

/**
 * back top
 *
 */
$(document).ready(function () {

    var bodyHeight = $('body').outerHeight(true);
    var pagetop = $(".js_pageTop");
    pagetop.hide();
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > bodyHeight) {
            pagetop.fadeIn("fast");
        } else {
            pagetop.fadeOut("fast");
        }

        if ($(window).width() > 768) {
            var scrollHeight = $(document).height();
            var scrollPosition = $(window).height() + $(window).scrollTop();
            var footHeight = $(".js_footer").innerHeight() - 50;

            if (scrollHeight - scrollPosition <= footHeight) {
                pagetop.css({
                    "position": "absolute",
                    //                "bottom": footHeight + 10
                    "bottom": footHeight + 25
                });
            } else {
                pagetop.css({
                    "position": "fixed",
                    //                "bottom": "10px"
                    "bottom": "25px"
                });
            }
        }
    });
    pagetop.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });

});

/**
 * back top
 *
 */
//$(document).ready(function () {
//
//    var bodyHeight = $('body').outerHeight(true);
//    var pagetop = $(".js_pageTop");
//    pagetop.hide();
//    $(window).on("scroll", function () {
//        if ($(this).scrollTop() > bodyHeight) {
//            pagetop.fadeIn("fast");
//        } else {
//            pagetop.fadeOut("fast");
//        }
//
//        if ($(window).width() > 768) {
//            var scrollHeight = $(document).height();
//            var scrollPosition = $(window).height() + $(window).scrollTop();
//            var footHeight = $(".js_footer").innerHeight() - 50;
//
//            if (scrollHeight - scrollPosition <= footHeight) {
//                pagetop.css({
//                    "position": "absolute",
//                    "bottom": footHeight + 25
//                });
//            } else {
//                pagetop.css({
//                    "position": "fixed",
//                    "bottom": "25px"
//                });
//            }
//        } else if ($(window).width() < 769) {
//            var scrollHeight = $(document).height();
//            var scrollPosition = $(window).height() + $(window).scrollTop();
//            var footHeight = $(".js_footer").innerHeight() - 50;
////            var footHeight = $(".js_footer").innerHeight() - 6;
//
//            if (scrollHeight - scrollPosition <= footHeight) {
//                pagetop.css({
//                    "position": "absolute",
//                    "top": scrollHeight - footHeight - 73,
////                    "top": scrollHeight - footHeight - 29,
//                    "bottom": 'auto'
//                });
//            } else {
//                pagetop.css({
//                    "position": "fixed",
//                    "bottom": "25px",
//                    "top": 'auto'
//                });
//            }
//        }
//    });
//    pagetop.click(function () {
//        $('body,html').animate({
//            scrollTop: 0
//        }, 500);
//        return false;
//    });
//
//});

/**
 * mainPadding setting
 *
 */
$(window).on("load resize", function () {
    var $headerHight = $('header').outerHeight(true);
    //    var $Main = $('.ly_contentWrap').not('.ly_contentWrap__top');
    var $Main = $('.ly_contentWrap');
    //    var $mvTop = $('.js_MV_top');
    var $gnavMenu = $('.js_gNav');

    $Main.css({
        paddingTop: $headerHight
    });
    //    $mvTop.css({
    //        paddingTop: $headerHight
    //    });
    $gnavMenu.css({
        top: $headerHight
    });
});

/**
 * header 背景変更
 *
 */
$(window).on('scroll', function () {
    if ($('.js_MV_top').height() < $(this).scrollTop()) {
        $('.js_header__top').addClass('change-color');
    } else {
        $('.js_header__top').removeClass('change-color');
    }
});

/**
 * mainHeight setting
 *
 */
$(function () {
    if ($(window).width() < 751 && $(".ly_sample")[0]) {
        var headerHight = $('header').outerHeight(true);
        var footerHight = $('footer').outerHeight(true);
        var winHight = $(window).height();
        var mainHight = winHight - headerHight - footerHight;
        //        $('main').css({
        //            minHeight: mainHight
        //        });
        $('.ly_contentWrap').css({
            minHeight: mainHight
        });
    }
});

/**
 * js_adjust_header_scroll
 *
 */
$(window).on("scroll", function () {
    $(".ly_header").css("left", -$(window).scrollLeft());
});

/**
 * reload breakpoint
 *
 */
if ($('.ly_sample')[0]) {
    const breakPoint01 = 769;
    const breakPoint02 = 768;
    let resizeFlag01;
    let resizeFlag02;

    window.addEventListener('load', function () {
        if (breakPoint01 < window.innerWidth) {
            resizeFlag01 = false;
        } else {
            resizeFlag01 = true;
        }
        resizeWindow01();
    }, false);

    window.addEventListener('load', function () {
        if (breakPoint02 > window.innerWidth) {
            resizeFlag02 = false;
        } else {
            resizeFlag02 = true;
        }
        resizeWindow02();
    }, false);

    const resizeWindow01 = function () {
        window.addEventListener('resize', function () {
            if (breakPoint01 < window.innerWidth && resizeFlag01) {
                window.location.reload();
                resizeFlag01 = false;
            } else if (breakPoint01 >= window.innerWidth && !(resizeFlag01)) {
                resizeFlag01 = true;
            }
        }, false);
    }
    const resizeWindow02 = function () {
        window.addEventListener('resize', function () {
            if (breakPoint02 > window.innerWidth && resizeFlag02) {
                window.location.reload();
                resizeFlag02 = false;
            } else if (breakPoint01 <= window.innerWidth && !(resizeFlag02)) {
                resizeFlag02 = true;
            }
        }, false);
    }
}

/**
 * toggle menu
 *
 */
var $window = $(window);
var $nav = $(".bl_nav");
//var $headerTop = $(".js_header");

function scroll_control(event) {
    event.preventDefault();
}

function no_scroll() {
    document.addEventListener("mousewheel", scroll_control, {
        passive: false,
    });
    document.addEventListener("touchmove", scroll_control, {
        passive: false,
    });
}

function return_scroll() {
    document.removeEventListener("mousewheel", scroll_control, {
        passive: false,
    });
    document.removeEventListener("touchmove", scroll_control, {
        passive: false,
    });
}

$(".js_nav_btnHamburger").on("click", function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
        //         bodyScrollLock.enableBodyScroll($headerTop);
        //        bodyScrollLock.clearAllBodyScrollLocks();
        $("body").css({
            overflow: "auto"
        });
    } else {
        //        bodyScrollLock.disableBodyScroll($headerTop);
        $("body").css({
            overflow: "hidden"
        });
    }
    $(this).stop().toggleClass("active");
    $(".js_overlay").stop().fadeToggle();
    $(".bl_nav_list_wrapper").stop().fadeToggle();
    $(".bl_nav_list_wrapper_inner").stop().toggleClass('on');
});

$(".js_overlay").on("click", function (e) {
    e.preventDefault();
    if ($(".js_nav_btnHamburger").hasClass("active")) {
        //         bodyScrollLock.enableBodyScroll($headerTop);
        //        bodyScrollLock.clearAllBodyScrollLocks();
        $("body").css({
            overflow: "auto"
        });
    } else {
        //         bodyScrollLock.disableBodyScroll($headerTop);
        $("body").css({
            overflow: "hidden"
        });
    }
    $(".js_nav_btnHamburger").stop().toggleClass("active");
    $(".js_overlay").stop().fadeToggle();
    $(".bl_nav_list_wrapper").stop().fadeToggle();
    $(".bl_nav_list_wrapper_inner").stop().toggleClass('on');
});

$(function () {
    $(".js-menu__item__link").each(function () {
        $(this).on("click", function () {
            $(this).stop().toggleClass("on");
            $("+.submenu", this).stop().fadeToggle();
            $(this).stop().toggleClass("active");
            return false;
        });
    });
});




//window.addEventListener('pageshow', function (event) {
//    if (event.persisted) {
//        // bfcache発動時の処理
//        //    window.location.reload();
//        var $body = document.body;
//        var $js_nav_btnHamburger = document.querySelectorAll(".js_nav_btnHamburger")[0];
//        var $js_overlay = document.querySelectorAll(".js_overlay")[0];
//        var $js_slideMenu_gnav = document.querySelectorAll(".js_slideMenu_gnav")[0];
//        var $js_slideMenu_gnav_inner = document.querySelectorAll(".js_slideMenu_gnav_inner")[0];
//
//        if ($js_nav_btnHamburger.classList.contains("active")) {
//            $body.style.overflow = 'auto';
//            $js_nav_btnHamburger.classList.remove("active");
//            $js_overlay.style.display = 'none';
//            $js_slideMenu_gnav.classList.remove("is_open");
//            $js_slideMenu_gnav_inner.classList.remove("on");
//        }
//    }
//});

window.onpageshow = function (event) {
    if (event.persisted) {

        // bfcache発動時の処理
        //            window.location.reload();
        var $body = document.body;
        var $js_nav_btnHamburger = document.querySelectorAll(".js_nav_btnHamburger")[0];
        var $js_overlay = document.querySelectorAll(".js_overlay")[0];
        var $js_slideMenu_gnav = document.querySelectorAll(".bl_nav_list_wrapper")[0];
        var $js_slideMenu_gnav_inner = document.querySelectorAll(".bl_nav_list_wrapper_inner")[0];

        if ($js_nav_btnHamburger.classList.contains("active")) {
            $body.style.overflow = 'auto';
            $js_nav_btnHamburger.classList.remove("active");
            $js_overlay.style.display = 'none';
            $js_slideMenu_gnav.style.display = 'none';
            $js_slideMenu_gnav_inner.classList.remove("on");
        }
    }
};

// ios page back event
// window.addEventListener('pageshow', function (event) {
//     if (event.persisted) {
//         unloadingWebsite();
//     }
//
// });
//
// function unloadingWebsite() {
//     var dc = $("body");
//     dc.classList.add('unloaded');
//     if ($(".js_nav_btnHamburger").hasClass("active")) {
//         $("body").css({
//             overflow: "auto"
//         });
//         $(".js_nav_btnHamburger").removeClass("active");
//         $(".js_overlay").fadeOut;
//         $(".bl_nav_list_wrapper").fadeOut;
//         $(".bl_nav_list_wrapper_inner").removeClass('on');
//     }
//
//     window.setTimeout(function () {
//
//         document.body.classList.remove('unloaded');
//
//     }, 200);
// }



/**
 * js_ofiImg
 *
 */
//if ($(".js_ofiImg")[0]) {
//    objectFitImages();
//}

/**
 * js_slick
 *
 */
//$(function () {
//    var $jsSlick = $('.js_slick');
//    if ($jsSlick[0]) {
//        $('.js_slick').slick({
//            autoplay: true,
//            autoplaySpeed: 5000,
//            slidesToShow: 1,
//            slidesToScroll: 1,
//            dots: true,
//            arrow: true,
//            prevArrow: '<img src="/_html/_assets/img/icons/icn_arrow.svg" class="slide-arrow prev-arrow">',
//            nextArrow: '<img src="/_html/_assets/img/icons/icn_arrow.svg" class="slide-arrow next-arrow">',
//            responsive: [{
//                breakpoint: 750,
//                settings: {
//                    //            edge: true,
//                }
//    }]
//        });
//    }
//});

/**
 * js_popup
 *
 */
//$(function () {
//    if ($('.js_popUp_iframe')[0] && $(window).width() < 751) {
//        $(".js_popUp_iframe").on("click", function (e) {
//            e.preventDefault();
//            $("body").css({
//                overflow: "hidden",
//            });
//            no_scroll();
//        });
//    }
//});
//$(function () {
//    if ($('.js_popUp_iframe')[0] && $(window).width() < 751) {
//        $(document).on('click', '.mfp-close , .mfp-wrap , .mfp-bg', function () {
//            $("body").css({
//                overflow: "auto",
//            });
//            return_scroll();
//        });
//    }
//});
//$(function () {
//    if ($('.js_popUp_iframe')[0]) {
//        $('.js_popUp_iframe').magnificPopup({
//            type: 'iframe',
//            mainClass: 'mfp-fade',
//            removalDelay: 200,
//            preloader: false,
//        });
//    }
//});

/**
 * js_matchHeight
 *
 */
//$(function () {
//    if ($('.ly_sample')[0]) {
//        $('.jsMatchHeight.bl_sample').matchHeight();
//        $('.jsMatchHeight.bl_sample').matchHeight();
//        if ($(window).width() > 751) {
//            $('.jsMatchHeight.bl_sample').matchHeight();
//        }
//    }
//
//    $(window).on('resize', function () {
//        if ($('.ly_sample')[0]) {
//            $('.jsMatchHeight.bl_sample').matchHeight();
//            $('.jsMatchHeight.bl_sample').matchHeight();
//            if ($(window).width() > 751) {
//                $('.jsMatchHeight.bl_sample').matchHeight();
//            }
//        }
//    });
//});

/**
 * js_accordion
 *
 */
$(function () {
    $('.js_accordion2_title').on('click', function () {
        $(this).next().slideToggle(200);
        $(this).toggleClass('is_open', 200);
    });
});


/**
 * js_tab
 *
 */
//$(function () {
//    $(".bl_tab_item").click(function () {
//        $(".is_active").removeClass("is_active");
//        $(this).addClass("is_active");
//        $(".is_show").removeClass("is_show");
//        var index = $(this).index();
//        $(".bl_panel_item").eq(index).addClass("is_show");
//    });
//});


/**
 * js_tab
 *
 */
$(function () {
    $(".bl_tab_item").click(function () {
        $(this).parents(".bl_tab").find(".is_active").removeClass("is_active");
        $(this).addClass("is_active");
        $(this).parents(".js_tabWrap").find(".is_show").removeClass("is_show");
        var index = $(this).index();
        $(this).parents(".js_tabWrap").find(".bl_panel_item").eq(index).addClass("is_show");
    });
});


/**
 * js_inputCheck
 *
 */
//$(document).ready(function () {
//    if ($('.js_inputCheck')[0]) {
//        var $submitBtn = $('.js_validateBtn');
//        $(document).on('blur', '.js_inputCheck input, .js_inputCheck select', function () {
//            if (
//                $('.js_inputCheck select[name="state"]').val() !== "" && $('.js_inputCheck select[name="range"]').val() !== "" &&
//                $('.js_inputCheck input[name="range_start"]').val() !== "" && $('.js_inputCheck input[name="range_end"]').val() !== "" && $('.js_inputCheck input[name="url"]').val() !== "" &&
//                $('.js_inputCheck input[type="password"]').val() !== "" && $('span.error').css('display') !== 'block'
//            ) {
//                $submitBtn.prop('disabled', false);
//
//            } else {
//                $submitBtn.prop('disabled', true);
//            }
//        });
//    }
//});


/**
 * js_filtering
 *
 */
//$(function () {
//    $(".js_filtering2_trg").click(function () {
//        var value = $(this).attr("data-filter");
//
//        if (value == "all") {
//            $(".js_filtering2_list").addClass("active");
//        } else {
//            $(".js_filtering2_list").not("." + value).removeClass("active");
//
//            $(".js_filtering2_list").filter("." + value).addClass("active");
//
//        }
//        $(".js_filtering2_trg").removeClass("active");
//        $(this).addClass("active");
//        $(".js_filtering2_trg").filter("." + value).addClass("active");
//
//
//        var adjust = $('header').outerHeight(true) + 50;
//        var speed = 800;
//
//        if ($(this).attr("data-filterttl")) {
//            var href = $(this).attr("data-filterttl");
//            //        var target = $(href == "#" || href == "" ? "html" : href);
//            var target = $(".js_filtering2_ttl").filter("#" + href);
//            var position = target.offset().top;
//            $("body,html").animate({
//                scrollTop: position - adjust
//            }, speed, "swing");
//            return false;
//        }
//    });
//});


/**
 * js_tab
 *
 */
//$(function () {
//    $(".js_filtering span").click(function () {
//        var value = $(this).attr("data-filter");
//        if (value == "all") {
//            $(".js_filtering_list").css({
//                display: "block",
//            });
//        } else {
//            $(".js_filtering_list")
//                .not("." + value)
//                .css({
//                    display: "none",
//                });
//            $(".js_filtering_list")
//                .filter("." + value)
//                .css({
//                    display: "block",
//                });
//        }
//        $(document).on("click", ".js_filtering span", function () {
//            $(".js_filtering span").removeClass("active");
//            $(this).addClass("active");
//        });
//    });
//    if (document.URL.match(/\?filter=fil-\w+$/)) {
//        var url = location.href;
//        url = (url.match(/\?filter=fil-\w+$/) || [])[0];
//        var params = url.split("?");
//        var fil = params[1].split("=");
//        console.log('params' + params);
//        if ($(fil).length) {
//            var filname = fil[1];
//
//            if ($(".js_filtering_list")[0]) {
//                $(".js_filtering_list").css({
//                    display: "none",
//                });
//                $(".js_filtering span").removeClass("active");
//                var filTab = $(".js_filtering span." + filname);
//                var filItem = $(".js_filtering_list." + filname);
//                $(filTab).addClass("active");
//                $(filItem).css({
//                    display: "block",
//                });
//            }
//        } else {
//            var filname = "all";
//            console.log(filname);
//        }
//    }
//});

/**
 * js_Parameter
 *
 */
//var params = getParameter();
//if (params['method'] !== "") {
//    if (params['method'] == "method1") {
//        //        $("#method_1").prop('checked', true);
//        console.log(params['method']);
//    } else if (params['method'] == "method2") {
//        //        $("#method_2").prop('checked', true);
//        console.log(params['method']);
//    }
//}

//function getParameter() {
//    var paramsArray = [];
//    var url = location.href;
//    parameters = url.split("#");
//    if (parameters.length > 1) {
//        url = parameters[0];
//    }
//    parameters = url.split("?");
//
//    if (parameters.length > 1) {
//        var params = parameters[1].split("&amp;");
//        for (i = 0; i < params.length; i++) {
//            var paramItem = params[i].split("=");
//            paramsArray[paramItem[0]] = paramItem[1];
//        }
//    }
//
//    return paramsArray;
//};

/**
 * js_ToggleMenu changeText
 *
 */
//$(function () {
//    $('.js_accordion_title').on('click', function () {
//        $(this).next().slideToggle(200);
//        $(this).next().toggleClass('is_open', 200);
//        $(this).toggleClass('is_open', 200);
//    });
//
//    $('.js_accordion2_btn').on('click', function () {
//        $(this).next().slideToggle(200);
//        $(this).next().toggleClass('is_open', 200);
//        $(this).toggleClass('is_open', 200);
//
//        if ($(this).text() === '詳細') {
//            $(this).text('閉じる');
//        } else {
//            $(this).text('詳細')
//        }
//    });
//});

/**
 * js_ToggleMenu
 *
 */
$(function () {
    if ($('.js_toggleTrigger1.is_show')[0]) {
        $('.js_toggleTrigger1.is_show').next('.js_toggleList_lv1').slideToggle('fast');
        $('.js_toggleTrigger1.is_show').find('.js_toggleTrigger1_icn').addClass('is_active');
    }
    $('.js_toggleTrigger').click(function () {
        $(this).next('.js_toggleList').slideToggle('fast');
        $(this).find('.js_toggleTrigger_icn').toggleClass('is_active');
    });
});


/**
 * js_sideNav
 *
 */
//$(function () {
//    if ($(".bl_sideNav")[0] && $(window).width() > 1040) {
//        $(window).on('load scroll resize', function () {
//            var $breadcrumbHeight = $('.bl_breadCrumb').outerHeight(true);
//            var $headerHeight = $('header').outerHeight(true);
//            var $winHeight = $(window).height();
//            //            var $scrollTop = $(window).scrollTop();
//            //            for fixed layout
//            var $scrollTop = $(window).scrollTop() + $headerHeight;
//            //            for fixed layout
//            var $navWrapTop = $('.ly_flexWrap_inner').offset().top;
//            var $sideNav = $('.bl_sideNav');
//            var $sideNavMaxHeight = $winHeight;
//            var $sideNavHeight = $('.bl_sideNav').height();
//            var $point1 = $scrollTop + $sideNavHeight;
//            var $end = $('footer').offset().top - 27;
//
//            $sideNav.css({
//                'max-height': $sideNavMaxHeight + 'px',
//            })
//
//            if ($scrollTop > $navWrapTop && $point1 < $end) {
//                $sideNav.removeClass('is_fixedBottom');
//                $sideNav.removeClass('is_fixedTop');
//                $sideNav.addClass('is_fixed');
//                $sideNav.css({
//                    'bottom': '',
//                    //                    'top': 0,
//                    //            for fixed layout
//                    'top': $headerHeight,
//                    //            for fixed layout
//                });
//            } else if ($scrollTop < $navWrapTop) {
//                $sideNav.removeClass('is_fixed');
//                $sideNav.removeClass('is_fixedBottom');
//                $sideNav.addClass('is_fixedTop');
//                $sideNav.css({
//                    'bottom': '',
//                    'top': 0,
//                });
//            } else if ($point1 > $end) {
//                $sideNav.removeClass('is_fixed');
//                $sideNav.removeClass('is_fixedTop');
//                $sideNav.addClass('is_fixedBottom');
//                $sideNav.css({
//                    'top': '',
//                    'bottom': 0,
//                });
//            }
//        });
//    }
//});


/**
 * js_noPrint
 *
 */
//$(function () {
//    if ($(".js_printCheck")[0]) {
//        $('.js_printCheck').change(function () {
//            if ($(this).is(':checked')) {
//                $(this).closest('.ly_cont').addClass('js_noPrint');
//            } else {
//                $(this).closest('.ly_cont').removeClass('js_noPrint');
//            }
//        });
//    }
//});


/**
 * js_megamenu(PC)
 *
 */
//$('.bl_nav_item').hover(
//    function () {
//        $(this).addClass('is_open');
//    },
//    function () {
//        $(this).removeClass('is_open');
//    }
//);


/**
 * js_accordion_gnav
 *
 */
$(function () {
    if ($(window).width() < 769) {
        $('.js_nav_link_accordionTrigger').on('click', function () {
            $(this).next().slideToggle(200);
            $(this).toggleClass('is_open', 200);
        });
    }
});

/**
 * js_accordion_footer
 *
 */
$(function () {
    if ($(window).width() < 769) {
        $('.js_nav_link_accordionTrigger2').on('click', function (e) {
            e.preventDefault();
            $(this).parents('.js_nav_link_accordionTrigger2Wrap').find('.js_nav_link_accordionContents2').slideToggle(200);
            $(this).toggleClass('is_open', 200);
        });
    }
});


//accordion input
//$(function () {
//    if ($(window).width() > 768) {
//        $('.js_nav_search_trigger').on('click', function (e) {
//            //            e.preventDefault();
//            //            console.log('open');
//            $(this).parents('.js_nav_search').find('.bl_nav_search_formWrap').toggleClass('is_open', 200);
//            $(this).toggleClass('is_open', 200);
//        });
//    }
//});


/**
 * js_megadropDown
 *
 */
$(function () {
    if ($(window).width() > 768) {
        $(".bl_nav_item").each(function () {
            $(this).hover(
                function () {
                    $('.js_nav_link_accordionContents').css({
                        'display': 'none',
                    });
                    $(this).find('.js_nav_link_accordionContents').fadeIn(300);
                },
                function () {
                    $(this).find('.js_nav_link_accordionContents').fadeOut(300);
                }

            );
        });
    };
});


/**
 * js_nav_search
 *
 */
$(function () {
    if ($(window).width() > 768) {
        $('.js_nav_search').on('click', function (e) {
            //            e.preventDefault();
            $('.js_nav_search_formBox').stop().fadeToggle(300);
            $(this).stop().toggleClass('active', 300);
        });
        $('.js_nav_search_close').on('click', function (e) {
            if ($('.js_nav_search').hasClass("active")) {
                $('.js_nav_search_formBox').fadeOut(300);
                $('.js_nav_search').removeClass('active', 300);
            }
        });
    }
});

/**
 * js_spMenu2
 *
 */
//$(function () {
//    $('.js_gnav_trigger').on('click', function () {
//        if ($(this).hasClass('is_active')) {
//            $("body").css({
//                overflow: "auto"
//            });
//            $(this).removeClass('is_active');
//            $('.bl_gnav_nav').removeClass('is_open');
//            $('.el_overlay2').removeClass('is_open');
//            setTimeout(function () {
//                $('#spMenu').removeClass('-dep1');
//                $('.bl_gnav_sub_item').removeClass('-current');
//            }, 500);
//        } else {
//            $("body").css({
//                overflow: "hidden"
//            });
//            $(this).addClass('is_active');
//            $('.bl_gnav_nav').addClass('is_open');
//            $('.el_overlay2').addClass('is_open');
//        }
//    });
//
//    $('.el_overlay2').on('click', function () {
//        if ($(this).hasClass('is_open')) {
//            $("body").css({
//                overflow: "auto"
//            });
//            $(this).removeClass('is_open');
//            $('.js_gnav_trigger').removeClass('is_active');
//            $('.bl_gnav_nav').removeClass('is_open');
//        }
//    });
//
//    var spSubCateOpenBtn = $('#spMenu .-depth');
//    var spSubCateCloseBtn = '#spMenu .bl_gnav_sub_ttl';
//    var spCateScroll;
//    spSubCateOpenBtn.on('click', spCateSub_open);
//    $(document).on('click', spSubCateCloseBtn, spCateSub_close);
//
//    function spCateSub_open() {
//        var cateDepth = $(this).parents('ul').length;
//        var openFlag = $(this).parents('.bl_gnav_sub_item, .bl_gnav_cate_item');
//        spCateScroll = $('#spMenu').scrollTop();
//        $('#spMenu .bl_gnav_cate_item').removeClass('-current');
//        $(this).next('.bl_gnav_sub_list').css('top', spCateScroll);
//        spSubCateOpenBtn.parent().removeClass('-current');
//        openFlag.addClass('-current');
//        $('#spMenu').addClass('-move -dep' + cateDepth);
//        setTimeout(function () {
//            $('#spMenu').removeClass('-move');
//        }, 500);
//        return false;
//    }
//
//    function spCateSub_close() {
//        var cateDepth = $(this).parents('ul').length - 1;
//        var openFlag = $(this).closest('.bl_gnav_sub_item, .bl_gnav_cate_item');
//        $('#spMenu').removeClass('-dep' + cateDepth);
//        setTimeout(function () {
//            openFlag.removeClass('-current');
//        }, 500);
//        return false;
//    }
//});
//window.addEventListener('pageshow', function (event) {
//  if (event.persisted) {
//    // bfcache発動時の処理
////    window.location.reload();
//     var $body = document.body;
//    var $js_nav_btnHamburger = document.querySelectorAll(".js_gnav_trigger")[0];
//    var $js_overlay = document.querySelectorAll(".el_overlay2")[0];
//    var $js_slideMenu_gnav = document.querySelectorAll(".bl_gnav_nav")[0];
////    var $js_slideMenu_gnav_inner = document.querySelectorAll(".js_slideMenu_gnav_inner")[0];
//
//    if ($js_nav_btnHamburger.classList.contains("is_active")) {
//        $body.style.overflow = 'auto';
//        $js_nav_btnHamburger.classList.remove("is_active");
////        $js_overlay.style.display= 'none';
//        $js_overlay.classList.remove("is_open");
//        $js_slideMenu_gnav.classList.remove("is_open");
////        $js_slideMenu_gnav_inner.classList.remove("on");
//    }  
//  }
//});



/**
 * js_3step
 *
 */
$(function () {
    if ($(".js_indicator")[0]) {
        var $jsIndicator = $('.js_indicator');
        var $sec1 = $('.bl_flex_item__1');
        var $sec2 = $('.bl_flex_item__2');
        var $sec3 = $('.bl_flex_item__3');

        var $sec1Height = $sec1.outerHeight(true);
        var $sec2Height = $sec2.outerHeight(true);

        var $jsIndicatorTop = $jsIndicator.offset().top;
        var $sec1Top = $sec1.offset().top;
        var $sec2Top = $sec2.offset().top;
        var $sec3Top = $sec3.offset().top;
        var $secTotal = $sec1Height + $sec2Height;

        var $headerHeight = $('header').outerHeight(true);

        $(window).on('load scroll resize', function () {
            var $scrollTop = $(window).scrollTop();
            var $winHeight = $(window).height();
            var $scrollBtm = $scrollTop + $winHeight;
            var $scrollTopHeader = $scrollTop + $headerHeight;

            if ($scrollTopHeader > $jsIndicatorTop && $scrollTopHeader > $sec3Top) {
                $jsIndicator.removeClass('is_fixed');
                $jsIndicator.css({
                    'top': $secTotal,
                });
            } else if ($scrollTopHeader > $jsIndicatorTop - 80) {
                $jsIndicator.addClass('is_fixed');
                $jsIndicator.css({
                    //                    'top': $headerHeight + 77,
                    'top': $headerHeight + 80,
                });
            } else {
                $jsIndicator.removeClass('is_fixed');
                $jsIndicator.css({
                    'top': 0,
                });
            }


            if ($scrollTopHeader > $sec3Top - 150) {
                $jsIndicator.removeClass('is_active__2');
                $jsIndicator.addClass('is_active__3');
            } else if ($scrollTopHeader > $sec2Top - 150) {
                $jsIndicator.removeClass('is_active__3');
                $jsIndicator.addClass('is_active__2');
            } else {
                $jsIndicator.removeClass('is_active__2');
                $jsIndicator.removeClass('is_active__3');
            }

        });
    }
});



/**
 * js_sideNav
 *
 */
$(function () {
    if ($(".js_sideNav")[0] && $(window).width() > 768) {
        var $jsSideNav = $('.js_sideNav');
        var $jsSideNavWrap = $('.js_sideNavWrap');

        //        var $jsSideNavTop = $jsSideNav.offset().top;
        //        var $jsSideNavHeight = $jsSideNav.outerHeight(true);
        //        var $jsSideNavWrapBottom = $jsSideNavTop + $jsSideNavHeight;
        var $jsSideNavHeight = $jsSideNav.outerHeight(true);
        var $jsSideNavTop = $jsSideNav.offset().top;
        var $jsSideNavBottom = $jsSideNavTop + $jsSideNavHeight;

        var $jsSideNavWrapTop = $jsSideNavWrap.offset().top;
        var $jsSideNavWrapHeight = $jsSideNavWrap.outerHeight(true);
        var $jsSideNavWrapBottom = $jsSideNavWrapTop + $jsSideNavWrapHeight;

        var $bottomPosition = $jsSideNavWrapHeight - $jsSideNavHeight;
        var $headerHeight = $('header').outerHeight(true);

        $(window).on('load scroll resize', function () {
            var $scrollTop = $(window).scrollTop();
            var $winHeight = $(window).height();
            var $scrollBtm = $scrollTop + $winHeight;
            var $scrollTopHeader = $scrollTop + $headerHeight;


            if ($scrollTopHeader > $jsSideNavTop) {
                $jsSideNav.addClass('is_fixed');
                $jsSideNav.css({
                    'top': $headerHeight + 77,
                });
            } else {
                $jsSideNav.removeClass('is_fixed');
                $jsSideNav.css({
                    'top': 0,
                });
            }

        });
    }
});



/**
 * js_sideNav
 *
 */
$(function () {
    if ($(".js_breadcrumb_arrow")[0] && $(window).width() > 768) {
        var $js_breadcrumb = $('.js_breadcrumb');
        var $js_breadcrumbArrow = $('.js_breadcrumb_arrow');

        $(window).on('load resize', function () {
            var $breadcrumbHeight = $js_breadcrumb.outerHeight(true);

            $js_breadcrumbArrow.css({
                //                'border-bottom-width': $breadcrumbHeight + 1,
                'border-bottom-width': $breadcrumbHeight,
            });
        });
    }
});


/**
 * js_langage
 *
 */
$(function () {
//    if ($(".pg_3step")[0] || $(".pg_3step_lv2")[0]|| $(".pg_contact")[0] || $(".pg_privacypolicy")[0] ) {
    if (!$(".js_lang_flag")[0]) {
        var $js_lang_header = $('.bl_nav_search_lang');
        var $js_lang_footer = $('.md_language');

        $js_lang_header.css({
            'display': 'none',
        });
        $js_lang_footer.css({
            'display': 'none',
        });
    }
});
